/* eslint-disable indent */
import ar from '@/local/ar';
import { subRequestType, legalCapacitiesEnum } from '@/modules/bankruptcy/helpers/enum';
import api from '@/modules/system/services/api.js';

export default {
    validateRelatedRequest: (payload) => {
        return new Promise((resolve, reject) => {
            const requestReasons = (payload.data.reasons || []).filter(r => !r.isDraft);
            if (payload.data.requestType.showRequestReasonSection && requestReasons.length < 1) {
                reject(ar.bankruptcy.subRequests.errors.reasonsNumberError);
            }

            if (payload.data.requestType.id === subRequestType.VerdictObjectionRequest) {
                if (payload.data.objectionFileId == null || payload.data.objectionFileId == undefined) {
                    reject(ar.bankruptcy.subRequests.errors.judgementAttachmentNotFound);
                }
            }
            if (payload.data.requestApplicant.legalCapacityId == legalCapacitiesEnum.lawyer) {
                api.validateLawyer(payload.data.requestApplicant.identityNumber, false).then(() => {
                    resolve();
                });
            } else {
                resolve();
            }
        });
    },
};
